
document.addEventListener(
  "click",
  function (e) {
    const path = e.composedPath && e.composedPath();
    if (!path) return;

    const redirectUrl =
      "https://cellphonepartsexpress.com/pages/b2b-registration";

    // Find the FIRST valid target
    const target = path.find(el =>
       (el?.tagName === "A" &&
        el.getAttribute("href") === "/a/saved-carts/new") ||
      (el?.tagName === "A" &&
        el.getAttribute("href") === "/a/saved-carts") ||
      (el?.tagName === "A" &&
        el.getAttribute("href") === "/a/customerhub#account") ||
      (el?.tagName === "BUTTON" &&
        el.getAttribute("name") === "checkout")
    );

    // Not our target → ignore
    if (!target) return;

    // OPT-OUT:
    // If THIS target (or its wrapper) has .te-btn → do nothing
    if (target.closest && target.closest(".te-btn")) {
      return;
    }

    // Apply custom behavior
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = redirectUrl;
  },
  true // capture phase (important)
);


